module.exports = __webpack_public_path__ + "static/media/Warranty.d63c2d51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/product-step/scrapping/Warranty.png
// module id = 1698
// module chunks = 0